import authRoles from "../../utils/auth.roles";
import VerificationSuccess from "./verificationSuccess";
const VerificationSuccessRoutes = {
  auth: authRoles.guest,
  kyc: false,
  routes: [
    {
      path: '/verification/success',
      component: VerificationSuccess,
      exact: true
    }
  ],
};
export default VerificationSuccessRoutes;
